/*
 * @Descripttion:
 * @Author: liang
 * @Date: 2021-07-16 11:26:28
 * @LastEditors: liang
 * @LastEditTime: 2025-05-30 18:29:19
 */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    navIndex: localStorage.getItem('navIndex') || '-1',
    isAddCourse: false,
    showBtn: localStorage.getItem('showBtn')
  },
  getters: { },
  mutations: {
    setNavIndex (state, navIndex) {
      state.navIndex = navIndex
      localStorage.setItem('navIndex', navIndex)
    },
    setIsAddCourse (state, val) {
      state.isAddCourse = val
      localStorage.setItem('isAddCourse', val)
    }
  },
  actions: {
    setNavIndex ({ commit }, data) {
      commit('setNavIndex', data)
    },
    setIsAddCourse ({ commit }, data) {
      commit('setIsAddCourse', data)
    }
  },
  modules: {}
})
